













































































































































import { Component, Vue } from "vue-property-decorator";
import { UsersApi } from "@/services/api-service";
import { NewUser } from "@/api/api";
// import AuthModule from "@/store/auth";
import { UserRegisterStatus } from "@/types";
import UserModule from "@/store/user";
import { Prefectures } from "@/constants";
import FormModal from "./FormModal.vue";

@Component({
  components: {
    FormModal,
  },
})
export default class CRegisterForm extends Vue {
  private mounted() {
    UserModule.commitRegisterStatus(UserRegisterStatus.Edit);
  }

  private form: NewUser = {
    name: "",
    nameFurigana: "",
    phoneNumber: "",
    address: {
      postalCode: "",
      prefecture: "",
      city: "",
      addressLine1: "",
      addressLine2: undefined,
    },
  };

  private get userRegisterStatus() {
    return UserRegisterStatus;
  }

  private get registerStatus() {
    return UserModule.registerStatus;
  }

  private confirm() {
    UserModule.commitRegisterStatus(UserRegisterStatus.Confirm);
    window.scrollTo(0, 0);
  }

  private async submit() {
    const { token } = this.$route.query;
    const usersApi = UsersApi.createInstance(token as string);
    try {
      const userRes = await usersApi.createUser(this.form);
      if (!userRes?.data?.data?.user) {
        return;
      }
      window.scrollTo(0, 0);
    } catch (err) {
      console.log(err);
    }
  }

  private backEdit() {
    UserModule.commitRegisterStatus(UserRegisterStatus.Edit);
    window.scrollTo(0, 0);
  }

  // ここからモーダル//
  private testShow() {
    (this.$refs.test as FormModal).CtestShow();
    this.submit();
  }
  // ここまでモーダル//

  // TODO: autocomplete
  private autoComplete() {
    console.log("complete");
  }

  private get prefectures() {
    return Prefectures;
  }
}
